/** `₹25,000` from whole paise, with Indian digit grouping (R8: money is integer paise). */
export function formatRupees(paise: number): string {
  const rupees = Math.floor(paise / 100);
  const digits = String(rupees);
  const last3 = digits.slice(-3);
  const rest = digits.slice(0, -3);
  const grouped = rest === '' ? last3 : `${rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${last3}`;
  return `₹${grouped}`;
}

/** Rupees typed by a person to whole paise. Returns null for anything that is not a number. */
export function rupeesToPaise(input: string): number | null {
  const cleaned = input.replace(/[,\s₹]/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const [whole, fraction = ''] = cleaned.split('.');
  return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
}

export function paiseToRupeesInput(paise: number | null): string {
  if (paise === null) return '';
  const rupees = Math.floor(paise / 100);
  const rest = paise % 100;
  return rest === 0 ? String(rupees) : `${String(rupees)}.${String(rest).padStart(2, '0')}`;
}

/** `₹8,844.10`: like `formatRupees`, but with the paise when there are any (an invoice total). */
export function formatRupeesExact(paise: number): string {
  const rest = paise % 100;
  return rest === 0
    ? formatRupees(paise)
    : `${formatRupees(paise)}.${String(rest).padStart(2, '0')}`;
}
